import { render } from "./SelectorLocaleFlag.vue?vue&type=template&id=65ecf44a&scoped=true"
import script from "./SelectorLocaleFlag.vue?vue&type=script&lang=js"
export * from "./SelectorLocaleFlag.vue?vue&type=script&lang=js"

import "./SelectorLocaleFlag.vue?vue&type=style&index=0&id=65ecf44a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65ecf44a"]])

export default __exports__